import EventBus from '@/event-bus';

export default {
  created() {
    EventBus.$on(this.deleteBus.onDelete, (id, text) => {
      this.deleteOptions.id = id;
      this.deleteOptions.text = text;
      this.deleteOptions.dialog = true;
    });
    EventBus.$on(this.deleteBus.deleted, () => {
      this.deleteOptions.dialog = false;
    });
    EventBus.$on(this.deleteBus.canceled, () => {
      this.deleteOptions.dialog = false;
    });
  },
  data() {
    return {
      deleteOptions: {
        dialog: false,
        id: 0,
        text: '',
      },
      deleteBus: {
        onDelete: 'deleteItem',
        deleted: 'deleted',
        canceled: 'cancelDelete',
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/mixins/deleteDialog.js